import { render, staticRenderFns } from "./CadastroRegiao.vue?vue&type=template&id=a42f4f38&scoped=true&"
import script from "./CadastroRegiao.vue?vue&type=script&lang=js&"
export * from "./CadastroRegiao.vue?vue&type=script&lang=js&"
import style0 from "./CadastroRegiao.vue?vue&type=style&index=0&id=a42f4f38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42f4f38",
  null
  
)

export default component.exports